import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//新增行
export const saveData = (params) => {
  return axios.post(root + '/set/salecoupon/save_from_web', qs.stringify(params))
}
//新增行
export const saleImport= (params) => {
  return axios.post(root + '/set/salecoupon/save_import_web', qs.stringify(params))
}
export const saleRemove= (params) => {
  return axios.post(root + '/set/salecoupon/remove', qs.stringify(params))
}


//获取列表数据
export const ListData = (params) => {
  return axios.post(root + '/set/salecoupon/datalist', qs.stringify(params))
}









// WEBPACK FOOTER //
// ./src/api/set/salecoupon.js